import { defineStyle } from '@chakra-ui/react';

export const MenuGroupStyles = defineStyle({
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
});
